@if (loaderService.isLoading()) {
  <div class="loader-overlay">
    <div class="loader-content">
      <div class="loader-icon-wrapper">
        <div class="spinner-ring"></div>
        <img ngSrc="assets/images/icons/favicon1.svg" alt="WorkApp" class="app-favicon" priority width="40" height="50">
      </div>
      @if (loaderService.loadingText()) {
        <div class="loading-text">{{ loaderService.loadingText() }}</div>
      }
    </div>
  </div>
}